const trustedDomains = [
  'gmail.com',
  'googlemail.com',
  'hotmail.com',
  'hotmail.com.br',
  'live.com',
  'live.com.br',
  'outlook.com',
  'outlook.com.br',
  'uol.com.br',
  'bol.com.br',
  'yahoo.com',
  'yahoo.com.br',
  'icloud.com',
  'me.com',
  'msn.com',
  'terra.com.br',
  'ig.com.br',
  'proton.me',
  'protonmail.com',
  'zoho.com',
  'aol.com',
  'gmx.com',
];

export const normalizeEmail = (value) => String(value || '').trim().toLowerCase();

export const emailValidationMessage = (value) => {
  const email = normalizeEmail(value);

  if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email) || email.includes('\n') || email.includes('\r')) {
    return 'Informe um e-mail válido.';
  }

  const domain = email.split('@').pop();
  if (trustedDomains.includes(domain)) return '';

  const alteredProvider = trustedDomains.some((trustedDomain) => domain.includes(trustedDomain));
  if (alteredProvider) {
    return 'Confira o domínio do e-mail. Use o endereço correto do seu provedor.';
  }

  return '';
};

export const isFullName = (value) => {
  const name = String(value || '').trim();
  return name.length >= 5
    && name.length <= 100
    && /^[\p{L}\s'-]+$/u.test(name)
    && name.split(/\s+/).filter(Boolean).length >= 2;
};
